import { db } from "../../../integrations/firebase";
import { ref, push, serverTimestamp, set } from "firebase/database";

export const LogsService = {
    logCall: async (userId, callData) => {
        try {
            const logsRef = ref(db, `users/${userId}/call_logs`);
            const newLogRef = push(logsRef);
            await set(newLogRef, {
                ...callData,
                loggedAt: serverTimestamp()
            });
        } catch (error) {
            console.error("Failed to log call:", error);
        }
    }
};
